(function () {
  'use strict';
  if (window.BFMobileScale) return;
  var mobile = window.matchMedia('(max-width: 767px)');
  // One length unit for the 390px artboard; do not depend on container-query units.
  var roots = [], observer = null, pending = false;
  function apply() {
    pending = false;
    roots.forEach(function (root) {
      if (!mobile.matches) { root.style.removeProperty('--bf-page-unit'); return; }
      var width = root.clientWidth;
      if (width > 0) root.style.setProperty('--bf-page-unit', (width / 390) + 'px');
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(apply);
  }
  function initialize() {
    roots = Array.prototype.slice.call(document.querySelectorAll('.bf-root'));
    if (observer) observer.disconnect();
    if (window.ResizeObserver) {
      observer = new window.ResizeObserver(schedule);
      roots.forEach(function (root) { observer.observe(root); });
    }
    apply();
  }
  window.BFMobileScale = { initialize: initialize };
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
  window.addEventListener('pageshow', schedule);
  if (mobile.addEventListener) mobile.addEventListener('change', schedule);
  else if (mobile.addListener) mobile.addListener(schedule);
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
